export { injectTranslations } from './injectTranslations';
